import { LucideIcon } from "lucide-react";

export function ShareHeader({
    icon: Icon,
    title,
    description,
    titleId,
}: {
    icon: LucideIcon;
    title: string;
    description: string;
    titleId?: string;
}) {
    return (
        <div className="flex items-start gap-2.5 border-b px-4 py-2.5">
            <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-secondary text-secondary-foreground">
                <Icon className="size-4" />
            </div>
            <div className="flex flex-col">
                <h3
                    id={titleId}
                    className="text-sm font-semibold leading-tight text-foreground"
                >
                    {title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-muted-foreground">
                    {description}
                </p>
            </div>
        </div>
    );
}
